import { routes as markHomewordDayView, MarkHomeworkDayView } from './MarkHomeworkDayView';
import { routes as markHomeworkCourseView } from './MarkHomeworkCourseView';

export default ({ getState }) => ({
  path: 'session/:sessionPlanId(/unit/:unitId)/paper-based',
  component: MarkHomeworkDayView,
  indexRoute: {
    onEnter: (nextState, replace) => {
      const viewMode = getState().get('rootReducer').get('uiState').get('viewMode');
      const isInCourseView = viewMode === 'course';
      return replace(
        `${withoutTrailingSlash(nextState.location.pathname)}/${isInCourseView ? 'course' : 'day'}`
      );
    },
  },
  showSessionCourseSwitch: true,
  childRoutes: [
    markHomewordDayView,
    markHomeworkCourseView,
  ],
});

function withoutTrailingSlash(path) {
  let out = path;
  if (path.substr(path.length - 1) === '/') {
    out = path.substr(0, path.length - 1);
  }
  return out;
}



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/routes.js